import { Naics } from "../naics";
import { Sic } from "../sic";
import { BizCompsSummary } from "./bizComps-summary";
import { BizCompsTransaction } from "./bizComps-transaction";
import { DealStatsSummary } from "./dealStat-summary";
import { DealStatsTransaction } from "./dealStat-transaction";
import { TransactionFilter } from "./transaction-filters";


export class IndustryRecord {
  ID: string;
  NAME: string;
  CODE: string;
  NAICS: string;
  SIC: string;

  NAICS_LIST: Naics[];
  SICS_LIST: Sic[];

  DEALSTATS_TRAN: DealStatsTransaction[];
  SELECTED_DEALSTATS_TRAN: DealStatsTransaction[];
  DEALSTATS_SUMMARY: DealStatsSummary[];
  SELECT_ALL_DS: boolean;
  INCLUDE_ALL_DS: boolean;

  BIZCOPMS_TRAN: BizCompsTransaction[];
  SELECTED_BIZCOMP_TRAN: BizCompsTransaction[];
  BIZCOPMS_SUMMARY: BizCompsSummary[];
  SELECT_ALL_BZ: boolean;
  INCLUDE_ALL_BZ: boolean;

  FILTERS: TransactionFilter[];

  UPDATE_DATE: Date;
  HAS_NEW: boolean;

  //helpers
  isLoading: boolean;
  RECENT: boolean = false;

  constructor(){
    this.CODE = '';
    this.NAICS = '';
    this.SIC = '';
    this.NAME = '';
    this.NAICS_LIST = [];
    this.SICS_LIST = [];
    this.DEALSTATS_TRAN = [];
    this.SELECTED_DEALSTATS_TRAN = [];
    this.DEALSTATS_SUMMARY = [];
    this.BIZCOPMS_TRAN = [];
    this.SELECTED_BIZCOMP_TRAN = [];
    this.BIZCOPMS_SUMMARY = [];
    this.FILTERS = [];
    this.UPDATE_DATE = null;
    this.HAS_NEW = false;
    this.SELECT_ALL_BZ = false;
    this.SELECT_ALL_DS = false;
  }

  static prepareRecord(json: IndustryRecord): IndustryRecord {
    if (json) {
      let f: any = {};

      if(json.ID) f['ID'] = json.ID;
      f['NAME'] = json.NAME;
      f['FILTERS'] = json.FILTERS;
      f['NAICS'] = [];
      if(json.NAICS){
        json.NAICS.split(' ').map((value) => {
          f.NAICS.push(Number(value));
        });
      }
      f['SIC'] = [];
      if(json.SIC){
        json.SIC.split(' ').map((value) => {
          f.SIC.push(Number(value));
        });
      }
      return f;
    } else { return null; }
  }

  static reset(): IndustryRecord{
    let f: IndustryRecord = new IndustryRecord();
    f.CODE = '';
    f.NAICS = '';
    f.SIC = '';
    f.NAME = '';
    f.NAICS_LIST = [];
    f.SICS_LIST = [];
    f.DEALSTATS_TRAN = [];
    f.SELECTED_DEALSTATS_TRAN = [];
    f.DEALSTATS_SUMMARY = [];
    f.BIZCOPMS_TRAN = [];
    f.SELECTED_BIZCOMP_TRAN = [];
    f.BIZCOPMS_SUMMARY = [];
    f.FILTERS = [];
    f.UPDATE_DATE = null;
    f.HAS_NEW = false;
    f.SELECT_ALL_BZ = false;
    f.SELECT_ALL_DS = false;

    return f;
  }
}
